import { BorderColor } from '../../ui-components/BackgroundContainer';

/**
 * Utility function to get consistent border color based on conditional id/index
 * This ensures that linked RegionalInfo and Conditional components have matching border colors.
 */
export const getConditionalBorderColor = (
    conditionalId: string | number | undefined
): BorderColor | undefined => {
    if (conditionalId === undefined || conditionalId === null) {
        return undefined;
    }

    // Array of border color names
    const colors: BorderColor[] = [
        'red',
        'blue',
        'green',
        'yellow',
        'purple',
        'pink',
        'indigo',
        'cyan',
        'orange',
        'teal',
    ];

    // Utility: convert a UUID string to a numeric hash
    function uuidToNumber(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
        }
        return Math.abs(hash);
    }

    let idx: number;

    if (typeof conditionalId === 'string') {
        idx = uuidToNumber(conditionalId);
    } else {
        idx = Math.abs(Number(conditionalId));
    }

    // Use modulo to cycle through colors
    return colors[idx % colors.length];
};
